import { Link } from 'react-router-dom'
import { LOADING_LABELS } from '../constants/loading'
import { ORDERS_PAGE, type RecentOrdersProps } from '../constants/orders'
import { formatCurrency, formatRelativeTime } from '../helpers/format'
import { deliveryPromiseLabel, orderStatusLabel } from '../helpers/orders'
import { Spinner } from './Spinner'
import '../styles/vendor-table.scss'
import '../styles/catalog-page.scss'
import '../styles/orders-page.scss'

export function RecentOrders({ orders, loading, error }: RecentOrdersProps) {
  return (
    <section className="panel">
      <div className="panel__header">
        <h2 className="panel__title">{ORDERS_PAGE.recentTitle}</h2>
        <Link to={ORDERS_PAGE.listPath} className="panel__link">
          {ORDERS_PAGE.allLink}
        </Link>
      </div>
      {error ? (
        <p className="table-empty">{error}</p>
      ) : loading ? (
        <Spinner block label={LOADING_LABELS.page} />
      ) : orders.length === 0 ? (
        <p className="table-empty">{ORDERS_PAGE.empty}</p>
      ) : (
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>{ORDERS_PAGE.colOrder}</th>
                <th>{ORDERS_PAGE.colRecipient}</th>
                <th>{ORDERS_PAGE.colCity}</th>
                <th>{ORDERS_PAGE.colStatus}</th>
                <th>{ORDERS_PAGE.colTotal}</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id}>
                  <td>
                    <p className="orders-cell__id">{order.orderNumber}</p>
                    <p className="cell-muted">
                      {formatRelativeTime(order.createdAt)} ·{' '}
                      {deliveryPromiseLabel(order.isExpress)}
                    </p>
                  </td>
                  <td>{order.delivery.recipientName}</td>
                  <td className="cell-muted">{order.delivery.city}</td>
                  <td>
                    <span className={`order-status order-status--${order.status}`}>
                      {orderStatusLabel(order.status)}
                    </span>
                  </td>
                  <td className="orders-cell__id">{formatCurrency(order.total)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
